import React from "react";
import { PaperSize, PAPER_SIZES } from "../../utils/constants";

interface SizeSelectorProps {
  selectedSize: PaperSize;
  onChange: (size: PaperSize) => void;
}

const SizeSelector: React.FC<SizeSelectorProps> = ({ selectedSize, onChange }) => (
  <div className="flex items-center space-x-3">
    <label className="text-gray-700 font-medium">Paper size</label>
    <select
      value={selectedSize}
      onChange={(e) => onChange(e.target.value as PaperSize)}
      className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
    >
      {Object.keys(PAPER_SIZES).map((key) => {
        const k = key as PaperSize;
        const s = PAPER_SIZES[k];
        return (
          <option key={key} value={key}>
            {key} — {s.width}×{s.height} mm
          </option>
        );
      })}
    </select>
  </div>
);

export default SizeSelector;
